export function demoFeaturesEnabled() {
  return process.env.ENABLE_DEMO_FEATURES === 'true';
}
